import { render, staticRenderFns } from "./GenerateTreatmentModal.vue?vue&type=template&id=33e205a0"
import script from "./GenerateTreatmentModal.vue?vue&type=script&lang=js"
export * from "./GenerateTreatmentModal.vue?vue&type=script&lang=js"
import style0 from "./GenerateTreatmentModal.vue?vue&type=style&index=0&id=33e205a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports